import { Button, Card, Checkbox, Col, Row, Tag } from "antd";
import {
  ArrowLeft,
  ArrowRightIcon,
  DownloadIcon,
  PlusIcon,
  SelectArrow,
} from "../../../../../../atoms/CustomIcons";
import Chart from "../../Chart";

export default function TabDashboard() {
  return (
    <div className="dashboardTabContent">
      <Row gutter={16} wrap={false}>
        <Col span={7}>
          <div className="checklist">
            <div className="title">
              <h4>Checklist</h4>
              <Button
                className="outlined-btn"
                size="small"
                style={{ height: "28px", width: "28px", padding: "0" }}
              >
                <PlusIcon />
              </Button>
            </div>
            <div className="content">
              <Card
                className="checklistCard dashboardChecklistCard"
                style={{ marginBottom: "8px" }}
              >
                <div className="checkList_listing">
                  <Checkbox checked>
                    Materials sourced and delivered to site
                  </Checkbox>

                  <div className="checklistFooter">
                    <Tag className="grey_tag"> Due: Apr 23 </Tag>
                    <div style={{ marginLeft: 8 }}>
                      <img
                        src="/images/potential-deals/avatar.png"
                        alt=""
                        style={{
                          width: "28px",
                          height: "28px",
                          border: "1px solid #C7D1D4",
                          borderRadius: "100%",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </Card>
              <Card
                className="checklistCard dashboardChecklistCard"
                style={{ marginBottom: "8px" }}
              >
                <div className="checkList_listing">
                  <Checkbox checked>
                    Initial groundwork started (e.g., clearing, grading, base
                    prep)
                  </Checkbox>

                  <div className="checklistFooter">
                    <div
                      style={{ marginLeft: "8px", display: "flex", gap: "8px" }}
                    >
                      <img
                        src="/images/dummy/dummy_wallet.svg"
                        alt=""
                        style={{
                          width: "28px",
                          height: "28px",
                          border: "1px solid #C7D1D4",
                          borderRadius: "100%",
                        }}
                      />
                      <img
                        src="/images/dummy/checkList_dp_1.png"
                        alt=""
                        style={{
                          width: "28px",
                          height: "28px",
                          border: "1px solid #C7D1D4",
                          borderRadius: "100%",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </Card>
              <Card
                className="checklistCard dashboardChecklistCard"
                style={{ marginBottom: "8px" }}
              >
                <div className="checkList_listing">
                  <Checkbox>Structural or layout elements underway</Checkbox>

                  <div className="checklistFooter">
                    <div
                      style={{ marginLeft: "8px", display: "flex", gap: "8px" }}
                    >
                      <img
                        src="/images/dummy/dummy_wallet.svg"
                        alt=""
                        style={{
                          width: "28px",
                          height: "28px",
                          border: "1px solid #C7D1D4",
                          borderRadius: "100%",
                        }}
                      />
                      <img
                        src="/images/dummy/dummy_add.svg"
                        alt=""
                        style={{
                          width: "28px",
                          height: "28px",
                          border: "1px solid #C7D1D4",
                          borderRadius: "100%",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </Card>
              <Card
                className="checklistCard dashboardChecklistCard"
                style={{ marginBottom: "8px" }}
              >
                <div className="checkList_listing">
                  <Checkbox>Hardscape installation in progress</Checkbox>

                  <div className="checklistFooter">
                    <div
                      style={{ marginLeft: "8px", display: "flex", gap: "8px" }}
                    >
                      <img
                        src="/images/dummy/dummy_wallet.svg"
                        alt=""
                        style={{
                          width: "28px",
                          height: "28px",
                          border: "1px solid #C7D1D4",
                          borderRadius: "100%",
                        }}
                      />
                      <img
                        src="/images/dummy/dummy_add.svg"
                        alt=""
                        style={{
                          width: "28px",
                          height: "28px",
                          border: "1px solid #C7D1D4",
                          borderRadius: "100%",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </Card>
            </div>
          </div>
        </Col>
        <Col span={17}>
          <div className="chart">
            <div className="title">
              <h4>Charts</h4>
              <div>
                <Button
                  className="outlined-btn"
                  size="small"
                  style={{
                    height: "28px",
                    width: "28px",
                    padding: "0",
                    marginRight: "4px",
                  }}
                  disabled
                >
                  <ArrowLeft className="disabledIcon" />
                </Button>
                <Button
                  className="outlined-btn"
                  size="small"
                  style={{ height: "28px", width: "28px", padding: "0" }}
                >
                  <ArrowRightIcon />
                </Button>
              </div>
            </div>
            <div className="content">
              <Card style={{ borderRadius: "16px", border: "unset" }}>
                <div
                  style={{
                    marginBottom: "16px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <h5> Profitability overview </h5>
                  <div style={{ display: "flex", gap: "8px" }}>
                    <div className="filterToggle">
                      <Button className="outlined-btn">
                        Entire contract
                        <div className="filter_icon">
                          <SelectArrow />
                        </div>
                      </Button>
                    </div>
                    <Button
                      icon={<DownloadIcon />}
                      style={{ height: "36px", width: "36px" }}
                    />
                  </div>
                </div>
                <Chart />
              </Card>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}
